export const required = (value, allValues, props, name) => {
  const requiredMsg = `This field is required`;

  value =
    typeof value === "string" || value instanceof String ? value.trim() : value;
  if (typeof value === "object" && value !== null) {
    if (value.location || value.details) {
      const details = value.details || {};
      return details.country &&
        details.postalCode &&
        details.state &&
        details.street &&
        details.suburb
        ? undefined
        : requiredMsg;
    }
  }
  return value || value === 0 ? undefined : requiredMsg;
};

export const email = value => {
  value =
    typeof value === "string" || value instanceof String ? value.trim() : value;
  return value &&
    !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
      value
    )
    ? "Invalid email address"
    : undefined;
};

export const match = (value, allValues) => {
  return value === allValues.order.email ? undefined : `Emails must match`;
};
country: "AU";
postalCode: "3230";
state: "VIC";
street: "3 Manna Gum Close";
suburb: "Anglesea";



// WEBPACK FOOTER //
// ./utils/Validators.js